<header>
    <div>
        <app-header-search></app-header-search>
    </div>
    <div>
        <app-header-notifications></app-header-notifications>
        <app-header-account></app-header-account>
    </div>
</header>